"use client";

import { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { useRequest } from "ahooks";
import { useToast } from "../components/ui/use-toast";
import { Loader2 } from "lucide-react";
import { cx } from "class-variance-authority";
import Image from "next/image";
const messageMap: Record<number, string> = {
  2017: "兑换码过期"
};
export default function Exchange() {
  const [exchangeCode, setExchangeCode] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const {
    toast
  } = useToast();
  const {
    runAsync,
    loading
  } = useRequest(async () => {
    const res = await fetch("/api/exchangeMember", {
      method: "POST",
      body: JSON.stringify({
        exchangeCode
      })
    });
    return res.json();
  }, {
    manual: true
  });
  const handleExchange = async () => {
    if (!exchangeCode) {
      setErrorMsg("请输入兑换码");
      return;
    }
    const res = await runAsync();
    if (res.code !== 0) {
      setErrorMsg(messageMap[res.code] ?? "兑换码无效");
      return;
    }
    toast({
      title: "兑换成功",
      variant: "default"
    });
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };
  return <div className="flex w-full flex-col items-center justify-center gap-6" data-sentry-component="Exchange" data-sentry-source-file="Exchange.tsx">
      <Image src="/exchangeBanner.png" alt="exchange" width={950} height={200} data-sentry-element="Image" data-sentry-source-file="Exchange.tsx" />
      <div className="flex w-full flex-col justify-start gap-4 px-5">
        <div className="w-fit text-xl font-medium">出海匠兑换码</div>
        <div className="flex flex-col gap-2">
          <div className="flex w-fit items-center justify-center rounded-md border-1 border-solid border-gray-200 ">
            <Input className="h-10 w-[400px] border-none bg-transparent focus-visible:ring-transparent focus-visible:ring-offset-0 " placeholder="请输入兑换码" value={exchangeCode} onChange={e => {
            setExchangeCode(e.target.value);
            setErrorMsg("");
          }} data-sentry-element="Input" data-sentry-source-file="Exchange.tsx" />
          </div>
          {errorMsg && <div className="text-sm text-red-500">{errorMsg}</div>}
          <div className="mt-10 text-xs text-gray-500">
            <div>出海匠兑换码使用说明：</div>
            <div className="mt-2 flex flex-col gap-1">
              <span>
                1. 每个用户仅可使用一次兑换码，兑换成功后即可获得会员权益
              </span>
              <span>2. 兑换码存在有效期，请在有效期内使用</span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex w-full justify-end">
        <Button disabled={loading} className={cx("gradient-btn", loading && "opacity-50")} onClick={handleExchange} data-sentry-element="Button" data-sentry-source-file="Exchange.tsx">
          立即兑换
          {loading && <Loader2 className="ml-2 h-4 w-4 animate-spin" />}
        </Button>
      </div>
    </div>;
}